import { createSlice } from '@reduxjs/toolkit';
import { pageModel } from '../../utils/model';

const initialState = {
    collectionSearchParams: {
        id: "",
        code: "",
        name: "",
        type: ""
    },
    collectionPage: pageModel,
    productPage: pageModel,
}

const productSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {
        setCollectionPageAction: (state, action) => {
            state.collectionPage = action.payload
        },
        getCollectionPageAction: (state, action) => {
            const content = state.collectionPage.content.concat(action.payload.content)
            state.collectionPage = { ...action.payload, content }
        },
        addCollectionAction: (state, action) => {
            state.collectionPage.content.unshift(action.payload)
        },
        deleteCollectionAction: (state, action) => {
            const content = state.collectionPage.content.filter(x => x.id !== action.payload)
            state.collectionPage.content = content
        },
        updateCollectionAction: (state, action) => {
            const content = state.collectionPage.content.map((x) => {
                if (x.id === action.payload.id) return action.payload
                else return x
            })
            state.collectionPage.content = content
        },
        setCollectionSearchParamsAction: (state, action) => {
            const { name, value } = action.payload.target
            state.collectionSearchParams = { ...state.collectionSearchParams, [name]: value }
        }
    },
});

export const { setCollectionSearchParamsAction, getCollectionPageAction, setCollectionPageAction, deleteCollectionAction, addCollectionAction, updateCollectionAction } = productSlice.actions;
export default productSlice;